export const V2_TABLES = Object.freeze({
  profiles: "profiles",
  dailyTargets: "daily_targets",
  mainFoods: "main_foods",
  customFoods: "custom_foods",
  foodLogs: "food_logs",
  medicationReminders: "medication_reminders",
  reminderEvents: "reminder_events",
  approvedTips: "approved_tips",
  quotes: "quotes",
  knowledgeFiles: "knowledge_files",
  knowledgeChunks: "knowledge_chunks",
  adminAuditLogs: "admin_audit_logs",
  appSettings: "app_settings",
});

export const V2_STORAGE_KEYS = Object.freeze({
  session: "ddp-v2-session",
  settings: "ddp-v2-profile-settings",
  profile: "ddp-v2-profile-settings",
  dailyTargets: "ddp-v2-profile-settings",
  foodLogs: "ddp-v2-food-logs",
  customFoods: "ddp-v2-custom-foods",
  medicationReminders: "ddp-v2-medication-reminders",
  reminderEvents: "ddp-v2-reminder-events",
  adminMainFoods: "ddp-v2-admin-main-foods",
  approvedTips: "ddp-v2-approved-tips",
  quotes: "ddp-v2-quotes",
  knowledgeItems: "ddp-v2-knowledge-items",
  appSettings: "ddp-v2-app-settings",
  adminAuditLogs: "ddp-v2-admin-audit-logs",
  guestCustomFoods: "ddp-v2-guest-custom-foods",
  guestFoodLogs: "ddp-v2-guest-food-logs",
  guestMedicationReminders: "ddp-v2-guest-medication-reminders",
  guestReminderEvents: "ddp-v2-guest-reminder-events",
});

export const V2_LEGACY_STORAGE_KEYS = Object.freeze({
  guestMode: "guestMode",
  guestProfile: "guestProfile",
});

export const V2_ALLOWED_LANGUAGES = Object.freeze(["en", "ar"]);

export const V2_ALLOWED_THEMES = Object.freeze(["light", "dark", "system"]);

export const V2_REMINDER_CHANNELS = Object.freeze({
  app: "app",
  whatsapp: "whatsapp",
  both: "both",
});

export const V2_ALLOWED_REMINDER_CHANNELS = Object.freeze(Object.values(V2_REMINDER_CHANNELS));

export const V2_REMINDER_FREQUENCIES = Object.freeze({
  daily: "daily",
  specificDays: "specific_days",
  once: "once",
});

export const V2_ALLOWED_REMINDER_FREQUENCIES = Object.freeze(Object.values(V2_REMINDER_FREQUENCIES));

export const V2_REMINDER_TIMES_PER_DAY_OPTIONS = Object.freeze([1, 2, 3, 4]);

export const V2_WEEKDAY_KEYS = Object.freeze(["sun", "mon", "tue", "wed", "thu", "fri", "sat"]);

export const V2_DEFAULT_DAILY_SYSTEM_REMINDER = Object.freeze({
  enabled: false,
  time: "19:30",
  message: "Review today's food log and medication reminders.",
});

export const V2_DEFAULT_PROFILE = Object.freeze({
  full_name: "",
  weight: "",
  weight_kg: "",
  language: "en",
  theme: "system",
  reminders_enabled: false,
  notifications_enabled: false,
  push_notifications_enabled: false,
  whatsapp_number: "",
  whatsapp_reminders_enabled: false,
  whatsapp_consent: false,
  whatsapp_include_medication_name: false,
  reminder_channel: "app",
});

export const V2_DEFAULT_REMINDERS = Object.freeze({
  enabled: false,
  notifications_enabled: false,
  push_notifications_enabled: false,
  whatsapp_number: "",
  whatsapp_reminders_enabled: false,
  whatsapp_consent: false,
  whatsapp_include_medication_name: false,
  channel: V2_REMINDER_CHANNELS.app,
  daily_system_reminder: V2_DEFAULT_DAILY_SYSTEM_REMINDER,
});

export const V2_DEFAULT_DAILY_TARGETS = Object.freeze({
  potassium_limit_mg: 3000,
  phosphorus_limit_mg: 1000,
  sodium_limit_mg: 2000,
  protein_limit_g: 60,
  show_weight_fluid_card: false,
  weight_target: "",
  fluid_limit_ml: "",
});

export const V2_DEFAULT_DAILY_LIMITS = Object.freeze({
  potassium_mg: 3000,
  phosphorus_mg: 1000,
  sodium_mg: 2000,
  protein_g: 60,
});

export const V2_DEFAULT_VISIBILITY = Object.freeze({
  weight_fluid_card: false,
});

export const V2_DEFAULT_SETTINGS = Object.freeze({
  profile: V2_DEFAULT_PROFILE,
  reminders: V2_DEFAULT_REMINDERS,
  daily_limits: V2_DEFAULT_DAILY_LIMITS,
  daily_targets: V2_DEFAULT_DAILY_TARGETS,
  visibility: V2_DEFAULT_VISIBILITY,
});

export const V2_KNOWLEDGE_ITEM_TYPES = Object.freeze({
  manualNote: "manual_note",
  pdf: "pdf",
  docx: "docx",
  txt: "txt",
  markdown: "markdown",
});

export const V2_ALLOWED_KNOWLEDGE_ITEM_TYPES = Object.freeze(Object.values(V2_KNOWLEDGE_ITEM_TYPES));

export const V2_DEFAULT_ADMIN_APP_SETTINGS = Object.freeze({
  show_weight_fluid_card: false,
  daily_system_reminder_time: "19:30",
  dashboard_tip_source: "admin",
  active_languages: ["en", "ar"],
  guidance_text: "This app is for guidance purposes only. Always consult your medical team.",
  whatsapp_provider_configured: false,
  default_whatsapp_message: "Reminder: it's time for your medication.",
  whatsapp_generic_message_default: true,
});

export const V2_FOOD_SOURCES = Object.freeze({
  main: "main",
  custom: "custom",
  manual: "manual",
});

export const V2_ALLOWED_FOOD_SOURCES = Object.freeze(Object.values(V2_FOOD_SOURCES));

export const V2_REMINDER_EVENT_STATUS = Object.freeze({
  taken: "taken",
  missed: "missed",
  snoozed: "snoozed",
  whatsapp: "whatsapp",
});

export const V2_ALLOWED_REMINDER_EVENT_STATUS = Object.freeze(Object.values(V2_REMINDER_EVENT_STATUS));

export const V2_FOOD_ICON_KEYS = Object.freeze({
  default: "food",
  main: "food",
  custom: "custom",
  manual: "manual",
  fruit: "fruit",
  vegetable: "vegetable",
  protein: "protein",
  grain: "grain",
  dairy: "dairy",
  meal: "meal",
});
